export default [
  {
    title: 'core.access_management',
    description:'core.access_management_description',
    children: [
      {
        title: 'core.users',
        icon: 'users',
        requiredPermissions: [
          'POST api/system/users/{id}',
          'DELETE api/system/users/{id}'
        ],
        target: 'system.user_list'
      },
      {
        title: 'core.approvers',
        icon: 'table',
        requiredPermissions: [
          'POST api/system/user_approval_roles/{id}',
          'DELETE api/system/user_approval_roles/{id}'
        ],
        target: 'system.approvers_list'
      },
      {
        title: 'core.roles',
        icon: 'shield-halved',
        requiredPermissions: [
          'POST api/system/roles/{id}',
          'DELETE api/system/roles/{id}'
        ],
        target: 'system.role_list'
      },
      {
        title: 'core.permissions',
        icon: 'lock',
        requiredPermissions: [
          'POST api/system/permissions/{id}',
          'DELETE api/system/permissions/{id}'
        ],
        target: 'system.permission_list'
      },
      {
        title: 'core.ip_addresses',
        icon: 'table',
        requiredPermissions: [
          'POST api/system/ipaddresses/{id}',
          'DELETE api/system/ipaddresses/{id}'
        ],
        target: 'system.ipaddress_list'
      },
      {
        title: 'core.user_regions',
        icon: 'table',
        requiredPermissions: [
          'POST api/system/regions/{id}',
          'DELETE api/system/regions/{id}'
        ],
        target: 'system.region_list'
      },
      {
        title: 'core.report_access',
        icon: 'lock',
        requiredPermissions: [
          'POST api/system/report_access/{id}',
          'DELETE api/system/report_access/{id}'
        ],
        target: 'system.report_access_list'
      },
      {
        title: 'core.template_management',
        icon: 'file-lines',
        requiredPermissions: [
          'POST api/system/template_files/{id}',
          'DELETE api/system/template_files/{id}'
        ],
        target: 'system.template_file_list'
      },
    ]
  }
]
